<template>
  <div style="background: #f9f9f9">
    <div class="soluBanner">
      <el-carousel
        indicator-position="outside"
        :interval="5000"
        :height="imgHeight + 'px'"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
            <img :src="item.value" alt="" style="width: 100%" ref="image"/>
          </a>
          <a v-else href="javascript:void(0)">
            <img :src="item.value" alt="" style="width: 100%" ref="image"/>
          </a>
          <div class="soluBanBox">
            <!--<h2>新闻中心</h2>
            <div class="soluBanText">
              <p>汇聚行业最新资讯</p>
              <p>RICH INDUSTRY SOLUTIONS AND CASES COVER ALL FIELDS</p>
            </div>-->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="soluBottomRTit flex">
      <div class="soluBottomRFlex flex">
        <div class="soluBottomRTit2" @click="findAll">
          <p>新闻中心</p>
          <i></i>
        </div>
        <i
          class="newsLittleIcon2"
          style="cursor: pointer"
          v-if="newListIndex != null"
        >
          >
        </i>
        <div
          class="newsLittleT"
          v-if="newListIndex != null"
          @click="handleOpen(newListIndex)"
        >
          <p>{{ newList[newListIndex].title }}</p>
          <!-- <i></i> -->
        </div>
        <i class="newsLittleIcon2" v-if="soluTabsIndex != null"> > </i>

        <div
          class="newsLittleT"
          v-if="newListIndex != null && soluTabsIndex != null"
        >
          {{ newList[newListIndex].children[soluTabsIndex].title }}
        </div>
      </div>

      <div class="soluBottomInput">
        <input type="text" placeholder="输入关键词" v-model="title" />
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="soluBottom flex">
      <div>
        <!-- <div
          class="soluBottomL"
          v-for="(newitems, indexs) in newList"
          :key="indexs"
        >
          <el-menu
            :class="indexs == newListIndex? 'el-menu-vertical-demo':''"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-submenu :index="indexs + ''">
              <template slot="title">
                <span>{{ newitems.title }}</span>
              </template>
              <el-menu-item-group>
                <div v-for="(items, index) in newitems.children" :key="index">
                  <el-menu-item
                    :index="indexs + '-' + index"
                    @click="getSoluTbas(indexs, index)"
                    >{{ items.title }}</el-menu-item
                  >
                </div>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div> -->
        <div class="soluBottomL">
          <el-menu @open="handleOpen" @close="handleClose" :unique-opened="true"
            ><div
              v-for="(newitems, indexs) in newList"
              :key="indexs"
              @click="fn(indexs)"
              :class="clickNum === indexs ? 'active' : ''"
            >
              <el-submenu :index="indexs + ''">
                <template slot="title">
                  <span>{{ newitems.title }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    :index="indexs + '-' + index"
                    @click="getSoluTbas(indexs, index)"
                    v-for="(items, index) in newitems.children"
                    :key="index"
                    >{{ items.title }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
            </div>
          </el-menu>
        </div>
      </div>

      <div class="soluBottomR">
        <div class="suluBottomBig" v-if="!showNoNews">
          <div
            class="soluBottomRList flex"
            v-for="(items, index) in solutionList"
            :key="index"
            @click="getNewsItemDetail(items.uuid)"
          >
            <div class="soluBottomRImg">
              <img :src="items.pictureUrl" alt="" />
            </div>
            <div class="soluBottomRMess">
              <h4>{{ items.title }}</h4>
              <!-- <p class="soluBottomRMessP" v-html="items.content"> -->
              <p class="soluBottomRMessP">
                {{ items.summary }}
              </p>
              <div class="new_times flex">
                <p>
                  <!-- {{ items.createDate }} -->
				  <!-- //修改成发布时间 -->
				  {{items.publishDate}}
                </p>
                <!--<p>
                  {{ items.time }}
                </p>-->
                <p class="flex" style="align-items: center">
                  <i class="iconfont" style="margin-right: 5px">&#xe611;</i>
                  <span> {{ items.pageViews }} </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showNoNews" class="suluBottomBig2">
			<!-- 暂无数据 -->
			<img src="../../assets/暂无搜索内容.jpg" style="width: 200px;" >
		</div>
        <!-- 分页 -->
        <div class="pageina" v-if="!showNoNews">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryNewText,
  getNewsProgramTreeList,
  getBannerList,
} from "../../utils/interface";
import { mapState } from "vuex";

export default {
  //   新闻
  name: "news",
  metaInfo: {
    title: '3D打印行业资讯——增材云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '3D打印|增材制造|3D打印行业资讯|3D打印新闻|3D打印政策|3D打印行业数据|3D打印技术|增材云|增材制造行业政策|树脂3D打印|金属3D打印|生物3D打印|智能制造'
    },{                 // set meta
      name: 'description',
      content: '增材云，每日精选3D打印业内重点新闻，及时传递价值讯息。增材云是安徽增材云数字科技有限公司打造的增材制造领域综合性工业互联网平台。聚合3D打印产业链六大资源，3D模型资源、设计师资源、生产制造资源、产品资源、课程资源、软件资源。并提供四大解决方案：智能制造标准体系的智能工厂解决方案、基于标识解析体系的远程运维解决方案、基于C2M模式的3D打印个性化定制解决方案、增材制造行业企业数字化解决方案。'
    }],
  },
  components: {},
  data() {
    return {
      showNoNews:false,
      clickNum: null,
      imgHeight: "",
      imgHeightsetIn: null,
      groupCode: "NEWS_BANNER",
      bannerList: [
        {
          value: "",
        },
      ],
      solutionList: [],
      newList: [
        {
          title: "",
          children: [
            {
              title: "",
            },
          ],
        },
      ],
      parkActiveIndex: 0,
      // 分页
      current: 1,
      pageSize: 10,
      total: 0,
      soluTabsIndex: null,
      newListIndex: null,
      programUuid: "",
      status: "PUBLISH",
      opends: ["0"],
      title: "",
      timer: null,
      setIn: null, // 定时器
      titleMessage: "",
      indexElmenu: false,
      defaultActive: "1",
    };
  },
  watch: {
    title() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getSolutionList();
      }, 100);
    },
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getBannerList();
        this.programUuid = this.$route.params.programUuid;
        this.getProgramList(this.programUuid);
        this.getSolutionList();
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    // if (this.bannerList.length !== 0) {
      window.addEventListener("resize", () => {
        this.imgHeight = this.$refs.image[0].height;
      });
    // }
  },
  methods: {
    imgLoad() {
      this.$nextTick(function () {
        // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
        // this.imgHeight = (document.body.clientWidth * 1) / 4;
        this.imgHeightsetIn = setInterval(() => {
          if (this.imgHeight == 0) {
            this.imgHeight = this.$refs.image[0].height;
            // console.log(5555, this.imgHeight);
          } else {
            clearInterval(this.imgHeightsetIn);
            // console.log(6666, this.imgHeight);
          }
        }, 520);
      });
    },
    handleOpen(key, keyPath) {
      this.newListIndex = key;
      this.programUuid = this.newList[key].uuid;
      this.soluTabsIndex = undefined;
      this.getSolutionList();
    },
    handleClose(key, keyPath) {
      this.newListIndex = undefined;
      this.soluTabsIndex = undefined;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSolutionList();
    },
    handleCurrentChange(val) {
      this.current = val;
	  window.scrollTo(0,0);
      this.getSolutionList();
    },
    getBannerList() {
      let params = {
        groupCode: this.groupCode,
      };
      getBannerList(params).then((res) => {
        // if (res.length !== 0) {
          this.bannerList = res;
          this.imgLoad();
        // }
      });
    },

    getProgramList(programUuid) {
      let params = {
        // name:'',
        // survival:this.survival,
        current: 1,
        pageSize: 10,
      };
      getNewsProgramTreeList(params).then((res) => {
        this.newList = res;
        // console.log(this.newList);
        if (programUuid != null) {
          this.newList.forEach((news, t) => {
            if (news.children != null) {
              news.children.forEach((item, tIndex) => {
                if (item.uuid == programUuid) {
                  item.active = true;
                  this.soluTabsIndex = tIndex;
                  this.newListIndex = t;
                } else {
                  item.active = false;
                }
              });
            }
          });
        }
      });
    },
    getSoluTbas(i, index) {
      // console.log("111", i, index);
      // // this.newList[i].children[index].active = true;
      this.programUuid =
        this.newList[i].children == null
          ? this.newList[i].uuid
          : this.newList[i].children[index].uuid;
      this.newList.forEach((news, t) => {
        if (news.children != null) {
          news.children.forEach((item, tIndex) => {
            if (i != t || tIndex !== index) {
              item.active = false;
            } else {
              item.active = true;
            }
          });
        }
      });
      this.soluTabsIndex = index;
      this.newListIndex = i;
      this.getSolutionList();
    },
    fn(index) {
      this.clickNum = index;
    },
    getSolutionList() {
      let params = {
        // name:'',
        status: 'PUBLISH',
        programUuid: this.programUuid,
        title: this.title,
        // programName:this.programName,
        current: this.current,
        pageSize: this.pageSize,
      };
      queryNewText(params).then((res) => {
        if (res.success) {
          this.solutionList = res.data;
          this.total = res.total;
          if(this.total>0){
            this.showNoNews=false;
          }else{
            this.showNoNews=true;
          }
        }else{
          this.showNoNews=true;
        }
      });
    },
    getNewsItemDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "newDetails",
        params: {
          uuid: uuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    findAll() {
      this.programUuid = null;
      this.newListIndex = null;
      this.soluTabsIndex = null;
      this.getSolutionList();
      this.newList.forEach((news, t) => {
        if (news.children != null) {
          news.children.forEach((item, tIndex) => {
            item.active = false;
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
.soluBanner {
  position: relative;
  width: 100%;
  img {
    width: 100%;
    display: block;
  }
  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;
    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }
    .soluBanText {
      p:nth-child(1) {
        font-size: 17px;
      }
      p:nth-child(2) {
        font-size: 9px;
      }
    }
  }
}
.soluBottomRTit {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0 0;
  line-height: 12px;
  border-bottom: 1px solid #efefef;
  justify-content: space-between;

  .soluBottomInput {
    position: relative;
    margin-bottom: 10px;
    input {
      border: none;
      background: #efefef;
      padding: 5px 13px;
      border-radius: 30px;
      height: 20px;
      width: 158px;
      font-size: 12px;
      color: #969696;
    }
    i {
      position: absolute;
      right: 5%;
      top: 50%;
      color: #969696;
      transform: translate(0, -50%);
    }
  }

  .soluBottomRFlex {
    align-items: center;
  }
  .soluBottomRTit2 {
    text-align: left;
    // width: 72px;
    cursor: pointer;
    position: relative;
    i {
      display: inline-block;
      background: #1181ff;
      width: 20px;
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    p {
      /*margin-bottom: 6px;*/
      line-height: 30px;
    }
  }
  .newsLittleT {
    font-size: 13px;
    color: #777;
    cursor: pointer;
  }
  // .newsLittleIcon {
  //   display: inline-block;
  //   width: 2px;
  //   height: 16px;
  //   background: #efefef;
  //   margin: 0 6px;
  // }
  .newsLittleIcon2 {
    display: inline-block;
    margin: 0 6px;
    color: #777;
  }
}
/deep/.el-submenu__title {
  font-size: 16px;
  border-bottom: 1px solid #efefef;
}
.active {
  background: #409eff;
  span {
  color: #fff !important;

  }
}
/deep/.el-submenu.is-active .el-submenu__title {
  border-bottom: 1px solid #efefef;
}
/deep/.el-submenu .el-menu-item {
  border-bottom: 1px solid #efefef;
}
/deep/.el-menu-item-group__title {
  padding: 0;
}
.soluBottom {
  width: 1200px;
  margin: 20px auto 0;
  padding-bottom: 40px;
  .soluBottomLtwo {
    background-color: #60a5f4;
    color: #fff;
    text-align: center;
    width: 255px;
    flex-shrink: 0;
  }
  .soluBottomL {
    // margin-bottom: 34px;
    text-align: center;
    width: 255px;
    flex-shrink: 0;
    background-color: #fff;
    .soluBottomLTit {
      font-size: 18px;
      color: #fff;
      background: #1181ff;
      text-align: center;
      height: 80px;
      line-height: 80px;
    }
    .soluBottomLtab {
      font-size: 14px;
      text-align: center;
      border: 1px solid #efefef;
      box-shadow: 0px 1px 7px 0px #dadada;

      p {
        height: 58px;
        line-height: 58px;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        // span {
        //   margin-left: 10px;
        // }
      }
      p:nth-last-child(1) {
        border-bottom: none;
      }
      .p_active {
        width: 100%;
        background: #e7f2ff;
      }
    }
    .soluBottomLtab_active {
      background: #1181ff;
      height: 15px;
      width: 3px;
      display: inline-block;
    }
  }
  .soluBottomR {
    margin-left: 28px;

    width: 100%;
    .suluBottomBig2 {
      margin-left: 28px;
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #d4d4d4;
      line-height: 650%;
    }
    .suluBottomBig {
      flex-wrap: wrap;
      justify-content: space-between;

      .soluBottomRList {
        cursor: pointer;
        background: #fff;
        margin-bottom: 18px;
        // width: 45%;
        // height: 120px;
        padding: 15px;
        border-radius: 10px;
        .soluBottomRImg {
          width: 260px;
          height: 132px;
          margin-right: 18px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .soluBottomRMess {
          position: relative;
          h4 {
            font-weight: 400;
            font-size: 15px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
              "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
              "Helvetica Neue";
          }
          .soluBottomRMessP {
            color: #777;
            font-size: 12px;
            margin-top: 14px;
            line-height: 22px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .new_times {
            position: absolute;
            font-size: 12px;
            color: #b1b1b1;
            bottom: 0;
            p:nth-child(2) {
              margin: 0 22px;
            }
          }
        }
      }
      .soluBottomRList:hover {
        box-shadow: 0px 1px 7px 0px #dadada;
      }
    }
    .pageina {
      margin-top: 74px;
      text-align: right;
    }
  }
}
/deep/.el-submenu__title:hover {
  background: #60a5f4;
  color: #fff;
}
/deep/.el-menu {
  background-color: none;
}
.soluBottomL /deep/ .el-submenu__title {
  // background: chartreuse;
}
// .el-menu-vertical-demo {
//   // background-color: #60a5f4;
//   span {
//     color: #fff;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue